import { render, staticRenderFns } from "./Ximi.vue?vue&type=template&id=9fe3fdd4&scoped=true"
import script from "./Ximi.vue?vue&type=script&lang=js"
export * from "./Ximi.vue?vue&type=script&lang=js"
import style0 from "./Ximi.vue?vue&type=style&index=0&id=9fe3fdd4&prod&lang=scss&scoped=true"
import style1 from "./Ximi.vue?vue&type=style&index=1&id=9fe3fdd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe3fdd4",
  null
  
)

export default component.exports